import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import StockDetailChart from "../Components/StockDetailChart";
import StockDetailTable from "../Components/StockDetailTable";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import { screenerData } from "../Service/data";
import { getListOfStocksInSignal } from "../Service/data";
import Divider from "@mui/material/Divider";
import StockNews from "../Components/StockNews";
import TimeControl from "../Components/TimeControl";

const MultiChartsView = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSignalData = async (signal) => {
      try {
        getListOfStocksInSignal(signal).then((data) => {
          setData(data);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const type = searchParams.get("type");
    if (type === "signal") {
      fetchSignalData(searchParams.get("name"));
    } else if (type === "screener") {
      searchParams.delete("type");
      let query = searchParams.toString();
      if (query.length > 0) {
        screenerData(query).then((data) => {
          // Array to store the values
          let listOfSymbols = [];

          // Iterate through the list of dictionaries using forEach
          data.forEach((dictionary) => {
            // Check if the key exists in the current dictionary
            if (dictionary.hasOwnProperty('symbol')) {
              // Add the value to the new list
              listOfSymbols.push(dictionary['symbol']);
            }
          });
          setData(listOfSymbols);
          setLoading(false);
        });
      } else {
        setNoData(true);
        setLoading(false);
        setData([]);
      }
    }
  }, []);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "30px",
        marginRight: "30px",
        marginTop: "20px",
      }}
    >
      <TimeControl />
      {loading && <CircularProgress />}
      {noData && <Typography>No data was received</Typography>}
      {data !== null &&
        data !== undefined &&
        data.map((row, index) => (
          <div key={index} style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h5">{row}</Typography>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              <StockDetailChart title={row} width={900} height={600}></StockDetailChart>
              <StockDetailTable title={row}></StockDetailTable>
            </div>
            <StockNews title={row}></StockNews>
            {index !== data.length - 1 && <Divider />}
          </div>
        ))}
    </div>
  );
};

export default MultiChartsView;
